import React from "react";
import { useNavigate } from "react-router-dom";
import { FaStar, FaUsers } from "react-icons/fa";

const LearnerHome = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <header className="container mx-auto px-6 py-16 text-center">
        <h1 className="text-5xl font-extrabold text-indigo-900 mb-4">
          Unlock Your Potential with{" "}
          <span className="text-pink-600">Vicademics</span>
        </h1>

        <p className="max-w-xl mx-auto text-lg text-indigo-700 mb-8">
          Explore thousands of courses from top instructors and start learning
          today.
        </p>

        {/* Ratings and Reviews Display */}
        <div className="flex justify-center items-center gap-6 mb-8 text-indigo-800 text-lg font-medium">
          <div className="flex items-center gap-2">
            <FaStar className="text-yellow-500" />
            <span>4.8 Average Rating</span>
          </div>
          <div className="flex items-center gap-2">
            <FaUsers className="text-pink-600" />
            <span>1200+ Reviews</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-4 mb-6">
          <button
            className="bg-pink-600 hover:bg-pink-700 text-white font-semibold px-8 py-3 rounded-lg shadow-lg transition"
            onClick={() => navigate("/browse-courses")}
          >
            Browse Courses
          </button>

          <button
            className="bg-white text-pink-600 hover:text-white border border-pink-600 hover:bg-pink-700 font-semibold px-8 py-3 rounded-lg shadow-lg transition"
            onClick={() => navigate("/learner/my-courses")}
          >
            My Courses
          </button>
        </div>
        
        {/* Vicademics Description */}
        <div className="max-w-3xl mx-auto mt-8 px-6">
          <p className="text-indigo-600 text-lg leading-relaxed">
            At <strong>Vicademics</strong>, we believe in empowering learners to achieve their full potential. 
            Our platform offers comprehensive courses designed by industry experts, interactive learning experiences, 
            and yearly access to help you master new skills and advance your career. Join thousands of successful 
            learners who have transformed their lives through quality education.
          </p>
        </div>
      </header>
    </div>
  );
};

export default LearnerHome;
